import React from 'react';
import { FinancingUser } from '@indigo-ag/schema';
import { palettes } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { createStylesHook } from 'shared';

interface AdminProps {
  user: FinancingUser;
  disabled: boolean;
  remove: (user: FinancingUser) => void;
  update: (user: FinancingUser) => void;
}
const useStyles = createStylesHook({
  optionsButton: {
    border: 0,
    background: 'transparent',
    display: 'flex',
    cursor: 'pointer',
    color: palettes.brand.blue.base
  },
  actionButtons: {
    display: 'flex'
  }
});

export const UserActions: React.FunctionComponent<AdminProps> = ({ user, disabled, remove, update }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const triggerRoleChange = () => {
    update(user);
  };

  const removeUserFromWhitelist = () => {
    remove(user);
  };

  return (
    <div className={classes.actionButtons}>
      <button onClick={triggerRoleChange} className={classes.optionsButton} disabled={disabled}>
        {i18next.t('edit')}
      </button>
      <button onClick={removeUserFromWhitelist} className={classes.optionsButton} disabled={disabled}>
        {i18next.t('remove')}
      </button>
    </div>
  );
};
